import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import { fetchAvailableTables } from "./query"; // Import der Funktion
import { updateSelectedDateTime, isDisabledDate } from "./utils";
import { PickersDay } from '@mui/x-date-pickers/PickersDay';

const DateTimePickerComponent = ({ setReservationState, selectedDate, selectedTime, restdays }) => {
   const [fullyBookedDates, setFullyBookedDates] = useState(new Set()); // Tage mit <= 0 freien Tischen
   const [criticalDates, setCriticalDates] = useState(new Set()); // Tage mit <= 3 freien Tischen
   const [semiCriticalDates, setSemiCriticalDates] = useState(new Set()); // Tage mit <= 5 freien Tischen

   // API-Aufruf beim Laden der Komponente
   useEffect(() => {
      const today = dayjs().format("YYYY-MM-DD");
      const endDay = dayjs().add(8, "day").format("YYYY-MM-DD");

      fetchAvailableTables(today, endDay)
         .then((data) => {
            const fullyBooked = new Set();
            const critical = new Set();
            const semiCritical = new Set();
            const avail = {};

            data.forEach(({ date, freeTables }) => {
               avail[date] = freeTables;
               if (freeTables <= 0) fullyBooked.add(date);
               else if (freeTables <= 3) critical.add(date);
               else if (freeTables <= 5) semiCritical.add(date);
            });

            setFullyBookedDates(fullyBooked);
            setCriticalDates(critical);
            setSemiCriticalDates(semiCritical);
         })
         .catch((error) => {
            console.error("Failed to fetch availability:", error);
         });
   }, []);


   function ServerDay(props) {
      const { criticalDates = [], semiCriticalDates = [], day, ...other } = props;
      const isCrossedOut = disabledDates(day);
      const isCriticalHighlighted = !isCrossedOut&&criticalDates.has(day.format('YYYY-MM-DD'));
      const isSemiCriticalHighlighted = !isCrossedOut&&semiCriticalDates.has(day.format('YYYY-MM-DD'));
   
      return (
         <PickersDay
            {...other}
            sx={{
               backgroundColor: isCriticalHighlighted ? "#ffcccc" : isSemiCriticalHighlighted ? "#fff3cd" : "",
               textDecoration: isCrossedOut ? "line-through" : "", 
            }}
            day={day}
         />
      );
   }

   // Datum deaktivieren und einfärben
   const disabledDates = (date) => {
      if (isDisabledDate(date)||fullyBookedDates.has(date.format('YYYY-MM-DD'))) {
         return true;
      }
      return restdays.some(item => dayjs(item.date).isSame(date, 'day'));
   };

   const handleDateChange = (newDate) => {
      const formattedDate = dayjs(newDate).format("YYYY-MM-DD");
      const isCritical = criticalDates.has(formattedDate);
      const isSemiCritical = semiCriticalDates.has(formattedDate);

      setReservationState((prevState) => ({
         ...prevState,
         selectedDateTime: updateSelectedDateTime(newDate, selectedTime),
         selectedDate: newDate,
         isCritical,
         isSemiCritical,
      }));
   };

   return (
      <MobileDatePicker
         skipDisabled
         color="baerendark"
         label="Datum"
         value={selectedDate || null}
         minDate={dayjs()}
         maxDate={dayjs().add(7, "day")}
         shouldDisableDate={disabledDates}
         onChange={handleDateChange}
         renderInput={(params) => <TextField color="baerendark" fullWidth {...params} />}
         slots={{
            day: ServerDay,
         }}
         slotProps={{
            day: {
               criticalDates,
               semiCriticalDates
            },
         }}
      />
   );
};

export default DateTimePickerComponent;
